module.exports = __webpack_public_path__ + "img/logo@2x.b08b55a6.png";